import { useState } from 'react';
import apiClient from '../utils/api';

interface MealEntry {
  preMealScore: number;
  postMealScore: number;
  calories?: number;
}

export const useMeals = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createMeal = async (entry: MealEntry): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      await apiClient.post('/meals', entry);
      return true;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to save meal. Please try again.';
      setError(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    createMeal,
    loading,
    error,
  };
};
